// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/images/heros/hero-image_2 -small.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/images/heros/hero-image_3.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../public/images/heros/hero-image_2-medium.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../public/images/heros/hero-image_2.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-color:#F4F6FF;
  --secondary-color:#F3C623;
  --tertiary-color:#EB8317;
  /* --dark-color:#10375C; */
}

html {
  scroll-behavior: smooth;
}

header {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  z-index: 9999;
  position: sticky;
  min-height: fit-content;
  background-color: var(--primary-color);
  top: 0;
  color: #10375C;
}

body {
  height: max-content;
  background-color: var(--primary-color);
}

button, a, input {
  min-width: 44px;
  min-height: 44px;
  display: inline-block;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Playfair Display";
}

header .skip-to-content {
  position: absolute;
  scroll-behavior: smooth;
  top: -100rem;
  left: 0;
  background-color: var(--primary-color);
  color: var(--secondary-color);
  padding: 10px;
  z-index: 9999;
  transition: top 0.3s ease;
  text-decoration: none;
}
header .skip-to-content:focus {
  top: 0;
  outline: 2px solid var(--secondary-color);
}
header .header {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
header .logo-icon {
  display: flex;
  align-items: center;
  margin-left: 1rem;
  font-family: "Playfair Display";
  gap: 0.5rem;
  font-size: 1rem;
  color: var(--dark-color);
  text-decoration: none;
}
header img {
  width: 45px;
}
header button {
  background-color: inherit;
  border: none;
  margin-left: 15%;
  display: flex;
  justify-content: end;
  align-items: center;
  cursor: pointer;
  min-width: 44px;
  min-height: 44px;
}
header .sidebar-mobile {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: scroll;
  min-height: 100vh;
  width: 72.5%;
  padding: 20px 10px;
  background-color: var(--primary-color);
  position: fixed;
  top: 0;
  left: 0;
  transform: translateX(-100%);
  transition: all 500ms ease-in-out;
  z-index: 99999;
}

ul {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-weight: bold;
}

nav #nav-list a.logo-icon {
  display: flex;
  justify-content: center;
  gap: 1.2rem;
  font-size: 1.15rem;
}

ul li a {
  display: block;
  padding: 10px 20px;
  border-radius: 4px;
  font-family: "Playfair Display";
  font-size: 1.15rem;
  color: var(--dark-color);
  text-decoration: none;
  transition: all 150ms ease-in-out;
}
ul li a:hover{
  background-color: var(--tertiary-color);
  color: #fff;
}

.sidebar-mobile.open {
  transform: translateX(0);
  box-shadow: 2px 0 6px 0 rgba(0, 0, 0, 0.25);
}

button {
  padding: 8px;
  border: 0;
  border-radius: 4px;
  background-color: transparent;
  font-weight: bold;
  font-size: 28px;
  color: var(--dark-color);
  cursor: pointer;
}

.close {
  display: none;
}

nav .follow-us {
  text-align: justify;
  padding: 0.25rem;
  font-family: "Lato";
}
nav .footer-sidebar {
  bottom: 15px;
  width: 100%;
  text-align: center;
  font-family: "Lato";
  justify-content: center;
  font-weight: bold;
}
nav .sidebar-mobile .follow-us {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  font-size: 1.2rem;
  border-radius: 0.5rem;
  -webkit-border-radius: 0.5rem;
  -moz-border-radius: 0.5rem;
  -ms-border-radius: 0.5rem;
  -o-border-radius: 0.5rem;
}
nav .sidebar-mobile .follow-us p#follow-us {
  font-weight: bold;
}
nav .sidebar-mobile .follow-us .social-media {
  display: flex;
  justify-content: center;
  padding-left: 1rem;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
}
nav .sidebar-mobile .follow-us .social-media a {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 1rem;
  text-decoration: none;
  color: var(--dark-color);
  font-size: 1rem;
}
nav .sidebar-mobile .follow-us .social-media p {
  border: 2px solid var(--primary-color);
}
nav .sidebar-mobile .follow-us .social-media p:hover {
  border-bottom: 2px solid #10375C;
}
nav .sidebar-mobile .follow-us .social-media img {
  width: 2.2rem;
  border-radius: 40%;
  -webkit-border-radius: 40%;
  -moz-border-radius: 40%;
  -ms-border-radius: 40%;
  -o-border-radius: 40%;
}

header .sidebar-mobile .deskripsi {
  text-align: justify;
}

nav#navbar-big {
  display: none;
}
nav ul li a:focus {
  outline: 2px solid var(--dark-color);
}

footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: var(--tertiary-color);
  padding: 0.5rem;
  margin-top: 1rem;
  text-align: center;
  font-weight: bold;
  font-size: 1.2rem;
  color: var(--primary-color);
}
footer .logo-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}
footer .logo-footer img {
  width: 3rem;
}
footer #copy-right {
  font-size: 1rem;
  margin-top: 0.5rem;
}

main {
  width: 100%;
  height: max-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 80vh;
}
main .hero {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: justify;
  color: var(--primary-color);
  background-size: cover;
  background-position: center;
  width: 100%;
  min-height: 350px;
  max-width: 1000px;
  margin: 0 auto;
  padding: 1rem;
  z-index: 0;
  overflow: hidden;
  background-color: black;
}
main .hero::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.65)), url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  z-index: 0;
  transition: transform 0.3s ease, filter 0.45s ease-in-out;
  -webkit-transition: transform 0.3s ease, filter 0.45s ease-in-out;
  -moz-transition: transform 0.3s ease, filter 0.45s ease-in-out;
  -ms-transition: transform 0.3s ease, filter 0.45s ease-in-out;
  -o-transition: transform 0.3s ease, filter 0.45s ease-in-out;
}
main .hero:hover::before {
  transform: scale(1.3) rotate(5deg);
  filter: brightness(0.6);
  -webkit-transform: scale(1.3) rotate(5deg);
  -moz-transform: scale(1.3) rotate(5deg);
  -ms-transform: scale(1.3) rotate(5deg);
  -o-transform: scale(1.3) rotate(5deg);
}
main .hero * {
  position: relative;
  z-index: 2;
}
main .hero .hero-content h1 {
  text-align: center;
  margin-bottom: 1.5rem;
}
main #daftar-restoran {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  width: 100%;
  font-family: "Playfair Display";
  padding-top: 2rem;
}
main #daftar-restoran .restoran {
  text-align: justify;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.5), 0 1px 3px rgba(0, 0, 0, 0.08);
  border-radius: 0.5rem;
  -webkit-border-radius: 0.5rem;
  -moz-border-radius: 0.5rem;
  -ms-border-radius: 0.5rem;
  -o-border-radius: 0.5rem;
}
main #daftar-restoran .restoran-bawah {
  padding: 1.5rem 1rem;
}
main #daftar-restoran .restoran-atas {
  display: flex;
  justify-content: space-between;
  align-items: end;
  color: var(--primary-color);
}
main #daftar-restoran .restoran-atas .location-icon {
  display: flex;
  justify-content: center;
  font-weight: bold;
  margin-bottom: 1rem;
  margin-left: 1rem;
  align-items: start;
  gap: 0.25rem;
}

#break {
  display: none;
}

main #daftar-restoran .restoran-atas .location-icon div {
  display: block;
  margin-top: auto;
  margin-bottom: auto;
}
main #daftar-restoran .restoran-atas .location-icon img {
  width: 2rem;
}
main #daftar-restoran .restoran-atas .rating-icon {
  display: flex;
  justify-content: center;
  font-weight: bold;
  margin-bottom: 1rem;
  margin-right: 1rem;
  align-items: end;
  gap: 0.25rem;
}
main #daftar-restoran .restoran-atas .rating-icon div {
  display: block;
  margin-top: auto;
  margin-bottom: auto;
  margin-bottom: auto;
}
main #daftar-restoran .restoran-atas .rating-icon img {
  width: 2rem;
}
main #daftar-restoran .restoran h2 {
  color: var(--dark-color);
}
main .restoran-atas {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 10rem;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

.custom-loader {
  width: 5rem;
  height: 5rem;
  background: #ffa600;
  border-radius: 50px;
  margin-left: auto;
  margin-right: auto;
  -webkit-mask: radial-gradient(circle 31px at 50% calc(100% + 13px),#000 95%,#0000) top 4px left 50%,
    radial-gradient(circle 31px,#000 95%,#0000) center,
    radial-gradient(circle 31px at 50% -13px,#000 95%,#0000) bottom 4px left 50%,
    linear-gradient(#000 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  -webkit-mask-repeat: no-repeat;
  animation: cu10 1.5s infinite;
}

@keyframes cu10 {
  0% {
    -webkit-mask-size: 0    18px,0    18px,0    18px,auto
  }

  16.67% {
    -webkit-mask-size: 100% 18px,0    18px,0    18px,auto
  }

  33.33% {
    -webkit-mask-size: 100% 18px,100% 18px,0    18px,auto
  }

  50% {
    -webkit-mask-size: 100% 18px,100% 18px,100% 18px,auto
  }

  66.67% {
    -webkit-mask-size: 0    18px,100% 18px,100% 18px,auto
  }

  83.33% {
    -webkit-mask-size: 0    18px,0    18px,100% 18px,auto
  }

  100% {
    -webkit-mask-size: 0    18px,0    18px,0    18px,auto
  }
}

/* Breakpoint untuk mobile 576px */
@media screen and (min-width: 576px) {
  body {
    background-color: var(--primary-color);
  }
  header svg {
    display: none;
  }
  header .header a h1 {
    color: var(--tertiary-color);
  }
  header .header a:focus h1 {
    color: var(--dark-color);
  }
  nav#navbar-big {
    display: flex;
  }
  header {
    display: flex;
    justify-content: space-around;
    background-color: inherit;
    height: fit-content;
    color: var(--tertiary-color);
    position: sticky;
    top: 0;
  }
  #break {
    display: inline;
  }
  nav#navbar-big ul {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 2rem;
  }
  header #navbar-big ul li a {
    color: var(--dark-color);
    border-radius: 5px;
    padding: 5px 20px;
    border: 2px solid none;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    -o-border-radius: 5px;
    outline: var(--tertiary-color);
  }
  body {
    height: min-content;
  }
  header #navbar-big ul li a:hover, header #navbar-big ul li a:focus {
    color: var(--primary-color);
    background-color: var(--tertiary-color);
    outline: none;
  }
  header #drawer-button, header .mobile-sidebar {
    display: none;
  }
  main .hero {
    min-width: 100%;
    text-align: center;
    background-color: black;
  }
  footer {
    padding-bottom: 1.5rem;
    min-height: 8rem;
  }
  main #daftar-restoran {
    display: grid;
    place-items: center;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 0.5rem 2rem;
    padding-left: 10%;
    padding-right: 10%;
  }
  main .hero::before {
    background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.65)), url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }

  .active-nav {
    color: var(--primary-color);
    background-color: var(--tertiary-color);
    outline: none;
  }
}

/* Breakpoint untuk tablet 768px */
@media screen and (min-width: 768px) {
  main .hero {
    min-height: 30rem;
  }
  main #daftar-restoran {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(325px, 1fr));
    gap: 0.5rem 2rem;
    padding-left: 15%;
    padding-right: 15%;
    padding-top: 5rem;
  }

  main .hero::before {
    background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.65)), url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,sCAAsC;EACtC,MAAM;EACN,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,OAAO;EACP,sCAAsC;EACtC,6BAA6B;EAC7B,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,MAAM;EACN,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;EACf,MAAM;EACN,OAAO;EACP,4BAA4B;EAC5B,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;EACrB,iCAAiC;AACnC;AACA;EACE,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mHAAiI;EACjI,sBAAsB;EACtB,2BAA2B;EAC3B,UAAU;EACV,yDAAyD;EACzD,iEAAiE;EACjE,8DAA8D;EAC9D,6DAA6D;EAC7D,4DAA4D;AAC9D;AACA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,0CAA0C;EAC1C,uCAAuC;EACvC,sCAAsC;EACtC,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,+BAA+B;EAC/B,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,uEAAuE;EACvE,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yDAAgE;EAChE,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB;;;6BAG2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,sCAAsC;EACxC;EACA;IACE,aAAa;EACf;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,6BAA6B;IAC7B,yBAAyB;IACzB,mBAAmB;IACnB,4BAA4B;IAC5B,gBAAgB;IAChB,MAAM;EACR;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,8BAA8B;EAChC;EACA;IACE,mBAAmB;EACrB;EACA;IACE,2BAA2B;IAC3B,uCAAuC;IACvC,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,4DAA4D;IAC5D,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,mHAAiI;EACnI;;EAEA;IACE,2BAA2B;IAC3B,uCAAuC;IACvC,aAAa;EACf;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,4DAA4D;IAC5D,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,mHAA0H;EAC5H;AACF","sourcesContent":[":root {\n  --primary-color:#F4F6FF;\n  --secondary-color:#F3C623;\n  --tertiary-color:#EB8317;\n  /* --dark-color:#10375C; */\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nheader {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  z-index: 9999;\n  position: sticky;\n  min-height: fit-content;\n  background-color: var(--primary-color);\n  top: 0;\n  color: #10375C;\n}\n\nbody {\n  height: max-content;\n  background-color: var(--primary-color);\n}\n\nbutton, a, input {\n  min-width: 44px;\n  min-height: 44px;\n  display: inline-block;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Playfair Display\";\n}\n\nheader .skip-to-content {\n  position: absolute;\n  scroll-behavior: smooth;\n  top: -100rem;\n  left: 0;\n  background-color: var(--primary-color);\n  color: var(--secondary-color);\n  padding: 10px;\n  z-index: 9999;\n  transition: top 0.3s ease;\n  text-decoration: none;\n}\nheader .skip-to-content:focus {\n  top: 0;\n  outline: 2px solid var(--secondary-color);\n}\nheader .header {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: space-between;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\nheader .logo-icon {\n  display: flex;\n  align-items: center;\n  margin-left: 1rem;\n  font-family: \"Playfair Display\";\n  gap: 0.5rem;\n  font-size: 1rem;\n  color: var(--dark-color);\n  text-decoration: none;\n}\nheader img {\n  width: 45px;\n}\nheader button {\n  background-color: inherit;\n  border: none;\n  margin-left: 15%;\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  cursor: pointer;\n  min-width: 44px;\n  min-height: 44px;\n}\nheader .sidebar-mobile {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  overflow-y: scroll;\n  min-height: 100vh;\n  width: 72.5%;\n  padding: 20px 10px;\n  background-color: var(--primary-color);\n  position: fixed;\n  top: 0;\n  left: 0;\n  transform: translateX(-100%);\n  transition: all 500ms ease-in-out;\n  z-index: 99999;\n}\n\nul {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  font-weight: bold;\n}\n\nnav #nav-list a.logo-icon {\n  display: flex;\n  justify-content: center;\n  gap: 1.2rem;\n  font-size: 1.15rem;\n}\n\nul li a {\n  display: block;\n  padding: 10px 20px;\n  border-radius: 4px;\n  font-family: \"Playfair Display\";\n  font-size: 1.15rem;\n  color: var(--dark-color);\n  text-decoration: none;\n  transition: all 150ms ease-in-out;\n}\nul li a:hover{\n  background-color: var(--tertiary-color);\n  color: #fff;\n}\n\n.sidebar-mobile.open {\n  transform: translateX(0);\n  box-shadow: 2px 0 6px 0 rgba(0, 0, 0, 0.25);\n}\n\nbutton {\n  padding: 8px;\n  border: 0;\n  border-radius: 4px;\n  background-color: transparent;\n  font-weight: bold;\n  font-size: 28px;\n  color: var(--dark-color);\n  cursor: pointer;\n}\n\n.close {\n  display: none;\n}\n\nnav .follow-us {\n  text-align: justify;\n  padding: 0.25rem;\n  font-family: \"Lato\";\n}\nnav .footer-sidebar {\n  bottom: 15px;\n  width: 100%;\n  text-align: center;\n  font-family: \"Lato\";\n  justify-content: center;\n  font-weight: bold;\n}\nnav .sidebar-mobile .follow-us {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  justify-content: center;\n  text-align: center;\n  font-size: 1.2rem;\n  border-radius: 0.5rem;\n  -webkit-border-radius: 0.5rem;\n  -moz-border-radius: 0.5rem;\n  -ms-border-radius: 0.5rem;\n  -o-border-radius: 0.5rem;\n}\nnav .sidebar-mobile .follow-us p#follow-us {\n  font-weight: bold;\n}\nnav .sidebar-mobile .follow-us .social-media {\n  display: flex;\n  justify-content: center;\n  padding-left: 1rem;\n  flex-direction: column;\n  gap: 1rem;\n  margin-top: 1rem;\n}\nnav .sidebar-mobile .follow-us .social-media a {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  gap: 1rem;\n  text-decoration: none;\n  color: var(--dark-color);\n  font-size: 1rem;\n}\nnav .sidebar-mobile .follow-us .social-media p {\n  border: 2px solid var(--primary-color);\n}\nnav .sidebar-mobile .follow-us .social-media p:hover {\n  border-bottom: 2px solid #10375C;\n}\nnav .sidebar-mobile .follow-us .social-media img {\n  width: 2.2rem;\n  border-radius: 40%;\n  -webkit-border-radius: 40%;\n  -moz-border-radius: 40%;\n  -ms-border-radius: 40%;\n  -o-border-radius: 40%;\n}\n\nheader .sidebar-mobile .deskripsi {\n  text-align: justify;\n}\n\nnav#navbar-big {\n  display: none;\n}\nnav ul li a:focus {\n  outline: 2px solid var(--dark-color);\n}\n\nfooter {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  background-color: var(--tertiary-color);\n  padding: 0.5rem;\n  margin-top: 1rem;\n  text-align: center;\n  font-weight: bold;\n  font-size: 1.2rem;\n  color: var(--primary-color);\n}\nfooter .logo-footer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n}\nfooter .logo-footer img {\n  width: 3rem;\n}\nfooter #copy-right {\n  font-size: 1rem;\n  margin-top: 0.5rem;\n}\n\nmain {\n  width: 100%;\n  height: max-content;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 80vh;\n}\nmain .hero {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: justify;\n  color: var(--primary-color);\n  background-size: cover;\n  background-position: center;\n  width: 100%;\n  min-height: 350px;\n  max-width: 1000px;\n  margin: 0 auto;\n  padding: 1rem;\n  z-index: 0;\n  overflow: hidden;\n  background-color: black;\n}\nmain .hero::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.65)), url(\"../public/images/heros/hero-image_2 -small.jpg\");\n  background-size: cover;\n  background-position: center;\n  z-index: 0;\n  transition: transform 0.3s ease, filter 0.45s ease-in-out;\n  -webkit-transition: transform 0.3s ease, filter 0.45s ease-in-out;\n  -moz-transition: transform 0.3s ease, filter 0.45s ease-in-out;\n  -ms-transition: transform 0.3s ease, filter 0.45s ease-in-out;\n  -o-transition: transform 0.3s ease, filter 0.45s ease-in-out;\n}\nmain .hero:hover::before {\n  transform: scale(1.3) rotate(5deg);\n  filter: brightness(0.6);\n  -webkit-transform: scale(1.3) rotate(5deg);\n  -moz-transform: scale(1.3) rotate(5deg);\n  -ms-transform: scale(1.3) rotate(5deg);\n  -o-transform: scale(1.3) rotate(5deg);\n}\nmain .hero * {\n  position: relative;\n  z-index: 2;\n}\nmain .hero .hero-content h1 {\n  text-align: center;\n  margin-bottom: 1.5rem;\n}\nmain #daftar-restoran {\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n  width: 100%;\n  font-family: \"Playfair Display\";\n  padding-top: 2rem;\n}\nmain #daftar-restoran .restoran {\n  text-align: justify;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.5), 0 1px 3px rgba(0, 0, 0, 0.08);\n  border-radius: 0.5rem;\n  -webkit-border-radius: 0.5rem;\n  -moz-border-radius: 0.5rem;\n  -ms-border-radius: 0.5rem;\n  -o-border-radius: 0.5rem;\n}\nmain #daftar-restoran .restoran-bawah {\n  padding: 1.5rem 1rem;\n}\nmain #daftar-restoran .restoran-atas {\n  display: flex;\n  justify-content: space-between;\n  align-items: end;\n  color: var(--primary-color);\n}\nmain #daftar-restoran .restoran-atas .location-icon {\n  display: flex;\n  justify-content: center;\n  font-weight: bold;\n  margin-bottom: 1rem;\n  margin-left: 1rem;\n  align-items: start;\n  gap: 0.25rem;\n}\n\n#break {\n  display: none;\n}\n\nmain #daftar-restoran .restoran-atas .location-icon div {\n  display: block;\n  margin-top: auto;\n  margin-bottom: auto;\n}\nmain #daftar-restoran .restoran-atas .location-icon img {\n  width: 2rem;\n}\nmain #daftar-restoran .restoran-atas .rating-icon {\n  display: flex;\n  justify-content: center;\n  font-weight: bold;\n  margin-bottom: 1rem;\n  margin-right: 1rem;\n  align-items: end;\n  gap: 0.25rem;\n}\nmain #daftar-restoran .restoran-atas .rating-icon div {\n  display: block;\n  margin-top: auto;\n  margin-bottom: auto;\n  margin-bottom: auto;\n}\nmain #daftar-restoran .restoran-atas .rating-icon img {\n  width: 2rem;\n}\nmain #daftar-restoran .restoran h2 {\n  color: var(--dark-color);\n}\nmain .restoran-atas {\n  background-image: url(\"../public/images/heros/hero-image_3.jpg\");\n  background-size: cover;\n  background-position: center;\n  width: 100%;\n  height: 10rem;\n  border-top-left-radius: 0.5rem;\n  border-top-right-radius: 0.5rem;\n}\n\n.custom-loader {\n  width: 5rem;\n  height: 5rem;\n  background: #ffa600;\n  border-radius: 50px;\n  margin-left: auto;\n  margin-right: auto;\n  -webkit-mask: radial-gradient(circle 31px at 50% calc(100% + 13px),#000 95%,#0000) top 4px left 50%,\n    radial-gradient(circle 31px,#000 95%,#0000) center,\n    radial-gradient(circle 31px at 50% -13px,#000 95%,#0000) bottom 4px left 50%,\n    linear-gradient(#000 0 0);\n  -webkit-mask-composite: xor;\n  mask-composite: exclude;\n  -webkit-mask-repeat: no-repeat;\n  animation: cu10 1.5s infinite;\n}\n\n@keyframes cu10 {\n  0% {\n    -webkit-mask-size: 0    18px,0    18px,0    18px,auto\n  }\n\n  16.67% {\n    -webkit-mask-size: 100% 18px,0    18px,0    18px,auto\n  }\n\n  33.33% {\n    -webkit-mask-size: 100% 18px,100% 18px,0    18px,auto\n  }\n\n  50% {\n    -webkit-mask-size: 100% 18px,100% 18px,100% 18px,auto\n  }\n\n  66.67% {\n    -webkit-mask-size: 0    18px,100% 18px,100% 18px,auto\n  }\n\n  83.33% {\n    -webkit-mask-size: 0    18px,0    18px,100% 18px,auto\n  }\n\n  100% {\n    -webkit-mask-size: 0    18px,0    18px,0    18px,auto\n  }\n}\n\n/* Breakpoint untuk mobile 576px */\n@media screen and (min-width: 576px) {\n  body {\n    background-color: var(--primary-color);\n  }\n  header svg {\n    display: none;\n  }\n  header .header a h1 {\n    color: var(--tertiary-color);\n  }\n  header .header a:focus h1 {\n    color: var(--dark-color);\n  }\n  nav#navbar-big {\n    display: flex;\n  }\n  header {\n    display: flex;\n    justify-content: space-around;\n    background-color: inherit;\n    height: fit-content;\n    color: var(--tertiary-color);\n    position: sticky;\n    top: 0;\n  }\n  #break {\n    display: inline;\n  }\n  nav#navbar-big ul {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 2rem;\n  }\n  header #navbar-big ul li a {\n    color: var(--dark-color);\n    border-radius: 5px;\n    padding: 5px 20px;\n    border: 2px solid none;\n    -webkit-border-radius: 5px;\n    -moz-border-radius: 5px;\n    -ms-border-radius: 5px;\n    -o-border-radius: 5px;\n    outline: var(--tertiary-color);\n  }\n  body {\n    height: min-content;\n  }\n  header #navbar-big ul li a:hover, header #navbar-big ul li a:focus {\n    color: var(--primary-color);\n    background-color: var(--tertiary-color);\n    outline: none;\n  }\n  header #drawer-button, header .mobile-sidebar {\n    display: none;\n  }\n  main .hero {\n    min-width: 100%;\n    text-align: center;\n    background-color: black;\n  }\n  footer {\n    padding-bottom: 1.5rem;\n    min-height: 8rem;\n  }\n  main #daftar-restoran {\n    display: grid;\n    place-items: center;\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    gap: 0.5rem 2rem;\n    padding-left: 10%;\n    padding-right: 10%;\n  }\n  main .hero::before {\n    background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.65)), url(\"../public/images/heros/hero-image_2-medium.jpg\");\n  }\n\n  .active-nav {\n    color: var(--primary-color);\n    background-color: var(--tertiary-color);\n    outline: none;\n  }\n}\n\n/* Breakpoint untuk tablet 768px */\n@media screen and (min-width: 768px) {\n  main .hero {\n    min-height: 30rem;\n  }\n  main #daftar-restoran {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(325px, 1fr));\n    gap: 0.5rem 2rem;\n    padding-left: 15%;\n    padding-right: 15%;\n    padding-top: 5rem;\n  }\n\n  main .hero::before {\n    background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.65)), url(\"../public/images/heros/hero-image_2.jpg\");\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
